import genActTypes from "../core/types";

const types = genActTypes("acf");

export default types;
